// Raw file bytes through the bridge, for previews (images): a blob by SHA,
// or a file at a commit. Kept in memory for the session, by content.
import { restBytes } from '../api/gh';
import { HttpError, LruMap } from '../api/cache';
import { encodePath } from './preview';

const memo = new LruMap<string, Promise<Uint8Array | null>>(60);

/** Where a file's bytes are: its blob SHA when known, else its path at a commit. */
export type RawSource = { sha: string } | { path: string; ref: string };

/** The bytes of a file, or null when it does not exist there. */
export function rawBytes(owner: string, repo: string, src: RawSource): Promise<Uint8Array | null> {
  const key = 'sha' in src ? src.sha : `${src.ref}:${src.path}`;
  let p = memo.get(key);
  if (!p) {
    p = load(owner, repo, src);
    memo.set(key, p);
    p.catch(() => memo.delete(key));
  }
  return p;
}

async function load(owner: string, repo: string, src: RawSource): Promise<Uint8Array | null> {
  const path =
    'sha' in src
      ? `repos/${owner}/${repo}/git/blobs/${src.sha}`
      : `repos/${owner}/${repo}/contents/${encodePath(src.path)}?ref=${encodeURIComponent(src.ref)}`;
  try {
    return await restBytes(path);
  } catch (e) {
    if (e instanceof HttpError && e.status === 404) return null;
    throw e;
  }
}
